import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { createRoot } from 'react-dom/client';
import ModalContext from '../ModalContext/ModalContext.js';

/**
 * Renderizza il componente (type con proprtieà properties) su un elemento del dom.
 * Essendo questo componente una modale,
 * ricevera in ingresso anche le props onClose, onConfirm, onCancel, resolve, reject
 * che se invocate chiuderanno il ciclo della promise ottenuta come ritorno della funzione.
 */
function createModalPromise(type, properties, id = 'temp-element') {
    const tempElement = document.createElement('div');
    tempElement.setAttribute('id', id);
    const dispose = (root) => {
        ModalContext.setOpenOrGlobal(false); // Trucco! La modale non viene "chiusa" ma distrutto il componente che la contiene.
        root.render(jsx("div", {}));
    }; // to destroy Confirm
    const confirmPromise = new Promise((resolve, reject) => {
        const root = createRoot(tempElement);
        const onClose = properties.onClose ? () => {
            dispose(root);
            if (properties.onClose) {
                properties.onClose();
            }
        } : () => dispose(root);
        root.render(React__default.createElement(type, Object.assign(Object.assign({}, properties), { onClose, onConfirm: resolve, onCancel: reject, resolve, reject })));
    });
    return confirmPromise;
}
/**
 * Funzione che controlla l'esistenza di un overlay di un modale o tour
 */
function existsModalOverlay() {
    const elements = document.querySelectorAll('.modal--overlay, .v2-modal__overlay, .tour__overlay');
    return elements.length > 0;
}

export { createModalPromise, existsModalOverlay };
